import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLanguageConfig, LANGUAGES, SITE_DIRECTIONS } from '../constants/appConstants';
import { selectLanguage } from '../api/ui/languageSlice';
import dayjs from 'dayjs';
import 'dayjs/locale/ar';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';
import commonByLang from '../locales/common.json';
import snackbarMessagesByLang from '../locales/snackbar_messages.json';
import validationsByLang from '../locales/validations.json';
import eInvoiceFormByLang from '../locales/eInvoiceForm.json';
import eInvoiceListPageByLang from '../locales/eInvoiceListPage.json';
import bulkUploadByLang from '../locales/bulkUpload.json';
import businessProfilesByLang from '../locales/businessProfiles.json';
import customersByLang from '../locales/customers.json';
import settingsByLang from '../locales/settings.json';
import navbarByLang from '../locales/navbar.json';
import documentReportsByLang from '../locales/documentReports.json';
import productsByLang from '../locales/products.json';
import suppliersByLang from '../locales/suppliers.json';
import registerByLang from '../locales/register.json';
import dashboardByLang from '../locales/dashboard.json';
import misDashboardByLang from '../locales/misDashboard.json';
import loginByLang from '../locales/login.json';
import usersByLang from '../locales/users.json';
import forgotPasswordByLang from '../locales/forgotPassword.json';
import proformaInvoicesByLang from '../locales/proformaInvoices.json';
import salesInvoiceRegisterByLang from '../locales/salesInvoiceRegister.json';
import purchaseInvoiceRegisterByLang from '../locales/purchaseInvoiceRegister.json';
import reconciliationByLang from '../locales/reconciliation.json';

export const DEFAULT_VALIDATION_MESSAGES = validationsByLang[LANGUAGES.EN] ?? {};

export function useTranslatedMessages() {
  const language = useSelector(selectLanguage);
  const languageConfig = getLanguageConfig(language);
  const direction = languageConfig.dir;

  dayjs.locale(languageConfig.dayjs);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.dir = direction;
      document.documentElement.lang = languageConfig.htmlLang;
    }
  }, [direction, languageConfig.htmlLang]);

  return {
    language,
    direction,
    isRTL: direction === SITE_DIRECTIONS.RTL,
    common: commonByLang[language ?? LANGUAGES.EN] ?? commonByLang.en ?? {},
    snackbarMessages: snackbarMessagesByLang[language ?? LANGUAGES.EN] ?? snackbarMessagesByLang[LANGUAGES.EN] ?? {},
    validations: validationsByLang[language ?? LANGUAGES.EN] ?? validationsByLang[LANGUAGES.EN] ?? {},
    eInvoiceForm: eInvoiceFormByLang[language ?? LANGUAGES.EN] ?? eInvoiceFormByLang[LANGUAGES.EN] ?? {},
    eInvoiceListPage: eInvoiceListPageByLang[language ?? LANGUAGES.EN] ?? eInvoiceListPageByLang[LANGUAGES.EN] ?? {},
    bulkUpload: bulkUploadByLang[language ?? LANGUAGES.EN] ?? bulkUploadByLang[LANGUAGES.EN] ?? {},
    businessProfiles: businessProfilesByLang[language ?? LANGUAGES.EN] ?? businessProfilesByLang[LANGUAGES.EN] ?? {},
    settings: settingsByLang[language ?? LANGUAGES.EN] ?? settingsByLang[LANGUAGES.EN] ?? {},
    customers: customersByLang[language ?? LANGUAGES.EN] ?? customersByLang[LANGUAGES.EN] ?? {},
    navbar: navbarByLang[language ?? LANGUAGES.EN] ?? navbarByLang[LANGUAGES.EN] ?? {},
    documentReports: documentReportsByLang[language ?? LANGUAGES.EN] ?? documentReportsByLang[LANGUAGES.EN] ?? {},
    products: productsByLang[language ?? LANGUAGES.EN] ?? productsByLang[LANGUAGES.EN] ?? {},
    suppliers: suppliersByLang[language ?? LANGUAGES.EN] ?? suppliersByLang[LANGUAGES.EN] ?? {},
    register: registerByLang[language ?? LANGUAGES.EN] ?? registerByLang[LANGUAGES.EN] ?? {},
    dashboard: dashboardByLang[language ?? LANGUAGES.EN] ?? dashboardByLang[LANGUAGES.EN] ?? {},
    misDashboard: misDashboardByLang[language ?? LANGUAGES.EN] ?? misDashboardByLang[LANGUAGES.EN] ?? {},
    login: loginByLang[language ?? LANGUAGES.EN] ?? loginByLang[LANGUAGES.EN] ?? {},
    users: usersByLang[language ?? LANGUAGES.EN] ?? usersByLang[LANGUAGES.EN] ?? {},
    forgotPassword: forgotPasswordByLang[language ?? LANGUAGES.EN] ?? forgotPasswordByLang[LANGUAGES.EN] ?? {},
    proformaInvoices: proformaInvoicesByLang[language ?? LANGUAGES.EN] ?? proformaInvoicesByLang[LANGUAGES.EN] ?? {},
    salesInvoiceRegister:
      salesInvoiceRegisterByLang[language ?? LANGUAGES.EN] ?? salesInvoiceRegisterByLang[LANGUAGES.EN] ?? {},
    purchaseInvoiceRegister:
      purchaseInvoiceRegisterByLang[language ?? LANGUAGES.EN] ?? purchaseInvoiceRegisterByLang[LANGUAGES.EN] ?? {},
    reconciliation: reconciliationByLang[language ?? LANGUAGES.EN] ?? reconciliationByLang[LANGUAGES.EN] ?? {},
  };
}
